// Import from original Constants.js
import {
    API_URL as ORIGINAL_API_URL,
    NODE_ENV,
    IMAGES_API_URL as ORIGINAL_IMAGES_API_URL,
    AUTH_TOKEN as ORIGINAL_AUTH_TOKEN,
    downloadFile,
    csvToArray,
} from '../Constants';

// API Constants - Use original values
export const API_URL = ORIGINAL_API_URL;
export const IMAGES_API_URL = ORIGINAL_IMAGES_API_URL;
export const AUTH_TOKEN = ORIGINAL_AUTH_TOKEN;

// Re-export utility functions
export { downloadFile, csvToArray };

// Event Types
export const EVENT_TYPES = {
    CONFERENCE: 'conference',
    EXHIBITION: 'exhibition',
    WORKSHOP: 'workshop',
    SEMINAR: 'seminar',
    WEBINAR: 'webinar',
    MEETING: 'meeting',
    OTHER: 'other',
};

// User Roles
export const USER_ROLES = {
    ADMIN: 'admin',
    ORGANIZER: 'organizer',
    STAFF: 'staff',
    ATTENDEE: 'attendee',
    EXHIBITOR: 'exhibitor',
    SPONSOR: 'sponsor',
    VOLUNTEER: 'volunteer',
    PARTICIPANT: 'participant',
    FACILITATOR: 'facilitator',
};

// Error Messages
export const ERROR_MESSAGES = {
    NETWORK_ERROR: 'Network error occurred. Please check your connection.',
    AUTHENTICATION_ERROR: 'Your session has expired. Please log in again.',
    AUTHORIZATION_ERROR: "You don't have permission to perform this action.",
    VALIDATION_ERROR: 'Invalid input provided. Please check your data.',
    SERVER_ERROR: 'A server error occurred. Please try again later.',
    NOT_FOUND: 'The requested resource was not found.',
    TIMEOUT_ERROR: 'Request timed out. Please try again.',
    UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
};

// Validation Rules
export const VALIDATION_RULES = {
    EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    PHONE: /^\+?[\d\s\-\(\)]{10,}$/,
    PASSWORD_MIN_LENGTH: 8,
    NAME_MIN_LENGTH: 2,
    NAME_MAX_LENGTH: 50,
};

// Pagination
export const PAGINATION = {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: [5, 10, 25, 50, 100],
    MAX_PAGE_SIZE: 100,
};

// Cache Keys
export const CACHE_KEYS = {
    USER_DATA: 'user_data',
    EVENT_DATA: 'event_data',
    DASHBOARD_DATA: 'dashboard_data',
    SETTINGS: 'app_settings',
    THEME: 'app_theme',
};

// Storage Keys
export const STORAGE_KEYS = {
    AUTH_TOKEN: AUTH_TOKEN,
    USER_PREFERENCES: 'user_preferences',
    THEME_MODE: 'theme_mode',
    LANGUAGE: 'language',
    SIDEBAR_COLLAPSED: 'sidebar_collapsed',
};

// Animation Durations
export const ANIMATION_DURATIONS = {
    FAST: 150,
    NORMAL: 300,
    SLOW: 500,
    VERY_SLOW: 800,
};

// Breakpoints
export const BREAKPOINTS = {
    XS: 0,
    SM: 600,
    MD: 960,
    LG: 1280,
    XL: 1920,
};

// Z-Index Values
export const Z_INDEX = {
    DRAWER: 1200,
    APP_BAR: 1100,
    MODAL: 1300,
    TOOLTIP: 1500,
    SNACKBAR: 1400,
    DROPDOWN: 1000,
};

// Date Formats
export const DATE_FORMATS = {
    SHORT: 'MMM dd, yyyy',
    LONG: 'EEEE, MMMM dd, yyyy',
    TIME: 'HH:mm',
    DATETIME: 'MMM dd, yyyy HH:mm',
    ISO: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
};

// File Types
export const FILE_TYPES = {
    IMAGE: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    DOCUMENT: [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
    SPREADSHEET: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    CSV: ['text/csv'],
    PRESENTATION: [
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ],
};

// Status Types
export const STATUS_TYPES = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
    DRAFT: 'draft',
};

// Notification Types
export const NOTIFICATION_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
};

// Export all constants
export default {
    API_URL,
    NODE_ENV,
    IMAGES_API_URL,
    AUTH_TOKEN,
    EVENT_TYPES,
    USER_ROLES,
    ERROR_MESSAGES,
    VALIDATION_RULES,
    PAGINATION,
    CACHE_KEYS,
    STORAGE_KEYS,
    ANIMATION_DURATIONS,
    BREAKPOINTS,
    Z_INDEX,
    DATE_FORMATS,
    FILE_TYPES,
    STATUS_TYPES,
    NOTIFICATION_TYPES,
    downloadFile,
    csvToArray,
};
